import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { InputAdornment, TextField, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import Plus from "../../../src/assests/images/Plus.svg";
import BrandsDropDown from "./BrandsDropDown";
import ProductCard from "./ProductCard";
import Banner from "./Banner";
import { getbrandsonly, getbannersonly } from "./api";
import { getToken } from "../../utils/utils";
import { format } from "date-fns";
import { useAlert } from "../../pages/AlertContext/AlertContext";
import FilterPopover from "../reports/FilterPopupv1";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';


{/* <style>
  {`
  .css-19kzrtu {
    border:"none"
  }
`}
</style> */}

function CustomTabPanel(props: any) {
  const { children, value, index, ...other } = props;
  const { showAlert } = useAlert();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0, border: "none" }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = useState(0);
  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  const [files, setFiles] = useState([]);
  const [keyVisualFiles, setKeyVisualFiles] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [brandDetails, setBrandDetails] = useState([]);
  const [bannerDetails, setBannerDetails] = useState([]);
  const [page, setPage] = useState(1);
  const [pagebanner, setPagebanner] = useState(1);
  const [limit, setLimit] = useState(10);
  const [limitbanner, setLimitbanners] = useState(10);
  const [totalBrands, setTotalBrands] = useState(0);
  const [totalBanners, setTotalBanners] = useState(0);
  const [appliedFilters, setAppliedFilters] = useState<Record<string, string[]>>({});
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [selectedRange, setSelectedRange] = useState("Today");
  const [applydetailes, setapply] = useState(false);
  const navigate = useNavigate();
  const token = getToken();

  const addOrdinalSuffix = (day: number) => {
    if (day > 3 && day < 21) return `${day}th`;
    switch (day % 10) {
      case 1:
        return `${day}st`;
      case 2:
        return `${day}nd`;
      case 3:
        return `${day}rd`;
      default:
        return `${day}th`;
    }
  };

  type SelectedFilters = Record<string, { value: string; id: string | null }[]>;
  const handleApplyFilters = (filters: SelectedFilters) => {
    console.log(filters, "filtersssssssssssss");
    // Extract values and IDs separately
    const transformedFilters: Record<string, string[]> = {};
    const filterIds: Record<string, (string | null)[]> = {};

    Object.keys(filters).forEach((key) => {
      // Handle values normally
      transformedFilters[key] = filters[key].map(item => item.value);

      if (key === "Tasks") {
        // For "Tasks", append the ids instead of replacing them
        filterIds[key] = (filterIds[key] || []).concat(filters[key].map(item => item.id));
      } else {
        // For other keys, just set the ids
        filterIds[key] = filters[key].map(item => item.id);
      }
    });

    // Save both value and id
    setAppliedFilters(transformedFilters);



    console.log("Applied Filtefffffrs:", transformedFilters);
    console.log("Filter IDs:", filterIds);
  };

  const aplliesfilterslocations = Array.isArray(appliedFilters.Location) && appliedFilters.Location.length > 0
    ? appliedFilters.Location.join(",")
    : "";

  console.log(aplliesfilterslocations, "aplliesfilterslocationsssssssssss")
  console.log(selectedRange, "5555666666666666666", applydetailes, selectedTab, "selectedTabselectedTab")
  const fetchBrands = async () => {
    try {
      const reqBody = {
        search: debouncedSearch,
        created_date: (selectedTab === 1 && applydetailes === true) ? selectedRange : '',
        location: aplliesfilterslocations,
        page: String(page),
        limit: String(limit),
      };

      const response = await getbrandsonly(reqBody, token);
      const { data } = response.data;

      setBrandDetails(
        data.finaluser_tasks.map((item: any) => ({
          id: item.id,
          title: item.brand_name,
          image: item.brand_images,
          price10: item.ten_pack_MRP_amount,
          price20: item.twenty_pack_MRP_amount,
          location: item.available_Locations,
          multiple_brand_images_count: item.multiple_brand_images_count,
          date: item.Request_on
            ? `${addOrdinalSuffix(
              new Date(item.Request_on).getDate()
            )} ${format(new Date(item.Request_on), "MMMM, yyyy")}`
            : "",
          status: item.status
        }))
      );
      setTotalBrands(data.totalcount);
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  };

  useEffect(() => {
    if (value === 0) {
      fetchBrands();
    }
  }, [value, debouncedSearch, aplliesfilterslocations, page, limit, token]);

  useEffect(() => {
    if (selectedTab === 1 && applydetailes && value === 0) {
      fetchBrands();
    }
  }, [selectedRange, selectedTab, applydetailes]);

  const [bannerImagesLength, setBannerImagesLength] = useState<string>("");

  const fetchBanners = async () => {
    try {
      const reqBody = {
        search: debouncedSearch,
        created_date: (selectedTab === 1 && applydetailes === true) ? selectedRange : '',
        location: aplliesfilterslocations,
        page: String(pagebanner),
        limit: String(limitbanner),
      };

      const response = await getbannersonly(reqBody, token);
      const { data } = response.data;

      setBannerDetails(
        data.finaluser_tasks.map((item: any) => ({
          id: item.id,
          image: item.large_banner_image,
          uploadOn: item.Request_on
            ? `${addOrdinalSuffix(
              new Date(item.Request_on).getDate()
            )} ${format(new Date(item.Request_on), "MMMM, yyyy")}`
            : "",
          banner_images_length: item.banner_images_length,
          banner_locations: item.available_Locations,
          banner_status: item.status
        }))
      );

      setTotalBanners(data.totalcount);
      setBannerImagesLength(
        data.finaluser_tasks.map((item: any) => item.banner_images_length).join(", ")
      );

    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  useEffect(() => {
    if (value === 1) {
      fetchBanners();
    }
  }, [value, debouncedSearch, aplliesfilterslocations, pagebanner, limitbanner, token]);

  useEffect(() => {
    if (selectedTab === 1 && applydetailes && value === 1) {
      fetchBanners();
    }
  }, [selectedRange, selectedTab, applydetailes]);

  console.log(value, "valuesssssss777777777777")

  console.log(bannerImagesLength, "bannerImagesLengthbannerImagesLengtheeee")
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);
  useEffect(() => {
    if (value === 1) {
      setDebouncedSearch("");
      setSearch("");
      setPage(1);
      setLimit(10);
      setBrandDetails([]);
    }
  }, [value]);
  const totalPages = Math.ceil(
    debouncedSearch ? brandDetails.length : totalBrands / limit
  );


  const totalPagesbanners = Math.ceil(
    debouncedSearch ? bannerDetails.length : totalBanners / limitbanner
  );
  console.log(brandDetails, "brandDetailswwwwqqqqq")

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [tags, setTags] = useState<string[]>([]);

  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);


  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget); // Open the popover
  };

  const handleClose = () => {
    setAnchorEl(null); // Close the popover

    setTimeout(() => {
      setapply(false); // Run after 1 second
    }, 1000); // 1000ms = 1 second
  };

  console.log(applydetailes, "appliedFisssssltersssssssssss")
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ padding: "0 32px" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          textColor="primary"
          TabIndicatorProps={{
            sx: {
              height: "2px",
              borderTop: "3px solid #C8172F",
              textTransform: "capitalize",
            },
          }}
        >
          <Tab
            label="Brands"
            sx={{
              "&.Mui-selected": {
                color: "#000",
                fontWeight: "bold",
                textTransform: "capitalize",
              },
              textTransform: "capitalize",
              paddingLeft: 0,
              paddingRight: 0,
              width: "auto",
              minWidth: "auto",
              maxWidth: "auto",
              marginRight: "30px"

            }}
          />
          <Tab
            label="Banners"
            sx={{
              "&.Mui-selected": {
                color: "#000",
                fontWeight: "bold",
                textTransform: "capitalize",
              },
              textTransform: "capitalize",
              paddingLeft: 0,
              paddingRight: 0,
              width: "auto",
              minWidth: "auto",
              maxWidth: "auto",
            }}
          />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            marginTop: "30px",
            padding: "0 32px",
            justifyContent: "space-between",
            marginBottom: "40px"


          }}
        >
          <Box sx={{ width: "423px" }}>
            <TextField
              variant="outlined"
              placeholder="Search by brand name, packs, location & pricing"
              fullWidth
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  height: "48px",
                  "& fieldset": {
                    borderColor: "#dddddd",
                  },
                  "&:hover fieldset": {
                    borderColor: "#dddddd",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#dddddd",
                  },
                },
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              width: "50%",
            }}
          >

            <Button sx={{ border: "1px solid #E7E8E9", borderRadius: "10px", padding: "11px 16px", color: "#282829", fontSize: "14px", fontWeight: "500", textTransform: "capitalize", marginRight: "16px" }} onClick={handleClick}>
              Filters
              {anchorEl ? <KeyboardArrowUpIcon sx={{ marginLeft: "8px" }} /> : <KeyboardArrowDownIcon sx={{ marginLeft: "8px" }} />}
            </Button>
            <Box>
              {/* <BrandsDropDown /> */}
              <FilterPopover

                anchorEl={anchorEl}
                onClose={handleClose}
                // onApply={handleApplyFilters}
                filterData1={[]} // optional if internal fetch is used
                tags={tags}
                setTags={setTags}
                appliedFilters={appliedFilters}
                startDate1={startDate}
                endDate1={endDate}
                onApply={handleApplyFilters}
                selectedRange={selectedRange}
                setSelectedRange={setSelectedRange}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab} applydetailes={applydetailes}
                setapply={setapply} />
            </Box>
            <Box>
              <Button
                onClick={() => navigate("/add-brand")}
                sx={{
                  borderRadius: "10px",
                  padding: "12px 16px",
                  color: "#FFF",
                  textDecoration: "none",
                  background: "rgba(200, 23, 47, 1)",
                  textAlign: "center",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none",
                }}
              >
                <img style={{ marginRight: "8px" }} src={Plus} alt="Plus" /> Add Brand
              </Button>
            </Box>
          </Box>
        </Box>
        <Box sx={{ padding: "0px", background: "#f7f9fa", borderTop: "1px solid #E7E8E9" }}>
          <ProductCard
            branddetails={brandDetails}
            page={page}
            limit={limit}
            totalPages={totalPages}
            setPage={setPage}
          />
        </Box>
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            marginTop: "20px",
            padding: "0 32px",
          }}
        >
          <Box sx={{ width: "50%" }}>
            <TextField
              variant="outlined"
              placeholder="Search by banner name, packs, location & pricing"
              fullWidth
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              width: "50%",
            }}
          >
            <Button sx={{ border: "1px solid #E7E8E9", borderRadius: "8px", padding: "14px 16px", color: "#282829", fontSize: "14px", fontWeight: "500", textTransform: "capitalize", marginRight: "16px" }} onClick={handleClick}>
              Filters
              {anchorEl ? <KeyboardArrowUpIcon sx={{ marginLeft: "8px" }} /> : <KeyboardArrowDownIcon sx={{ marginLeft: "8px" }} />}
            </Button>
            <Box>
              {/* <BrandsDropDown /> */}
              <FilterPopover
                anchorEl={anchorEl}
                onClose={handleClose}
                // onApply={handleApplyFilters}
                filterData1={[]}
                tags={tags}
                setTags={setTags}
                appliedFilters={appliedFilters}
                startDate1={startDate}
                endDate1={endDate}
                onApply={handleApplyFilters} selectedRange={selectedRange} setSelectedRange={setSelectedRange} selectedTab={selectedTab} setSelectedTab={setSelectedTab} applydetailes={applydetailes}
                setapply={setapply} />
            </Box>
            <Box>
              <Button
                onClick={() => navigate("/add-banner")}
                sx={{
                  borderRadius: "8px",
                  padding: "14px 16px",
                  color: "#FFF",
                  textDecoration: "none",
                  background: "rgba(200, 23, 47, 1)",
                  textAlign: "center",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none",
                }}
              >
                <img style={{ marginRight: "8px" }} src={Plus} alt="Plus" /> Add Banner
              </Button>
            </Box>
          </Box>
        </Box>
        <Box>
          <Banner
            bannerdetails={bannerDetails}
            page={pagebanner}
            limit={limitbanner}
            totalPages={totalPagesbanners}
            setPage={setPagebanner}
            bannerImagesLength={bannerImagesLength}
          />
        </Box>
      </CustomTabPanel>
    </Box>
  );
}


